<!--
 * @Description:导入预采购任务量
 * @Date: 2023/4/20 下午3:41:37
-->
<template>
  <base-dialog
    :visible="true"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    title="预采购任务量"
    width="700px"
  >
    <div style="margin: 0 auto; padding: 30px">
      <base-form
        ref="formRef"
        :model="form"
        label-width="auto"
        label-position="right"
      >
        <base-form-item
          :rules="[{ required: true, message: '请选择日期' }]"
          label="预采购时间："
          prop="prePurchaseAt"
        >
          <base-date-picker
            :disabledDate="disabledDate"
            v-model="form.prePurchaseAt"
          ></base-date-picker>
        </base-form-item>
        <base-form-item label="预采购任务量：" prop="">
          <div>
            <p>
              <base-button
                :icon="Download"
                type="text"
                @click="downLodTaskPlanExcel"
              >
                下载剩余量
              </base-button>
              <base-button
                :icon="Download"
                type="text"
                @click="procurementPersonnel"
              >
                下载数据模板
              </base-button>
            </p>

            <BaseUpload
              ref="upload"
              v-model:fileList="fileList"
              style="width: 360px"
              :http-request="httpRequest"
              :auto-upload="true"
              :multiple="false"
              :accept="['.xls', '.xlsx']"
              :onError="onError"
              :limit="1"
              :limit-size="20"
              :drag="true"
              btnText="上传人员名单"
            >
              <template #tip>
                上传格式为 xls 或 xlsx 文件，最大支持20M。
              </template>
            </BaseUpload>
          </div>
        </base-form-item>
        <base-form-item
          :rules="[{ required: true, message: '请选择导入方式' }]"
          label="导入方式："
          prop="importMethod"
        >
          <div>
            <base-radio-group v-model="form.importMethod">
              <base-radio :value="1">覆盖原数据</base-radio>
              <base-radio :value="2">累加原数据</base-radio>
            </base-radio-group>
          </div>
        </base-form-item>
        <base-form-item
          v-if="form.importMethod === 1"
          label=""
          prop="coverMethod"
          :rules="[{ required: true, message: '请选择覆盖方式' }]"
        >
          <div style="background: #fafafa; padding: 10px">
            <base-radio-group v-model="form.coverMethod">
              <base-radio :value="1">
                按当前表单执行，非表单内的人员任务量清空，
                <span style="color: #ff3535">并置于往期人员</span>
              </base-radio>
              <base-radio :value="2">
                修改当前表单内的人员任务量，非表单内人员任务量不变
                <span style="color: #ff3535">【同属于当期人员】</span>
              </base-radio>
            </base-radio-group>
          </div>
        </base-form-item>
        <base-form-item
          v-if="form.importMethod === 2"
          label=""
          prop="summationMethod"
          :rules="[{ required: true, message: '请选择累加方式' }]"
        >
          <div style="background: #fafafa; padding: 10px">
            <base-radio-group v-model="form.summationMethod">
              <base-radio :value="1">
                累加当前表单内人员的任务量与剩余量，非表单内的执行人任务量清零，
                <span style="color: #ff3535">并置于往期人员</span>
              </base-radio>
              <base-radio :value="2">
                只累加当前表单内人员的任务量，非表单内的执行人任务量不变
                <span style="color: #ff3535">【同属于当期人员】</span>
              </base-radio>
            </base-radio-group>
          </div>
        </base-form-item>
      </base-form>
      <base-button
        v-if="!isSceneType19"
        type="danger"
        plain
        @click="removeLatestTask"
      >
        上期预采购任务量清零
      </base-button>
    </div>
    <template #footer>
      <BaseButton @click="onCancel" type="default">取消</BaseButton>
      <BaseButton :click="onConfirm" type="primary">确认</BaseButton>
    </template>
  </base-dialog>
</template>
<script lang="tsx" setup>
import {
  defineProps,
  withDefaults,
  reactive,
  ref,
  defineEmits,
  computed
} from 'vue';
import {
  BaseButton,
  BaseDatePicker,
  BaseDialog,
  BaseForm,
  BaseFormItem,
  BaseFormRef,
  BaseRadio,
  BaseRadioGroup,
  BaseUpload,
  XrkMessage,
  XrkLoading,
  XrkMessageBox,
  createDialog,
  BaseCheckbox
} from 'xrk-components';
import { Download } from '@element-plus/icons-vue';
import {
  downloadTemplate,
  downloadSurplus,
  cleanProjectWorkload,
  checkImportExcel,
  importProjectPeople,
  againSubmit
} from '../data-source/apis';
import { uploadApi } from '@data-source/common/apis';

import ProjectPersonFailTable from './project-person-fail-table.vue';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import { formatter } from '@/utils';

const store = useProjectDetailStore();
const projectInfo = computed(() => store.baseData.projectInfo);
//是否是个体
const isGeti = computed(() => {
  return projectInfo.value.ctype === 3;
});
// 表单实例
const formRef = ref<BaseFormRef>(null);
// upload上传
const upload = ref(null);
const fileList = ref([]);
// 声明 prop 属性
const props = withDefaults(
  defineProps<{
    remove?: () => {};
    isSceneType19: boolean;
  }>(),
  {
    remove() {
      return () => ({});
    }
  }
);
const emits = defineEmits(['success']);
const disabledDate = time => {
  const cur = new Date();
  const curDate = cur.getDate() - 1;
  cur.setDate(curDate);
  return time.getTime() < cur.getTime();
};
const form = reactive<{
  projectId: number; //项目id
  projectCode: string;
  prePurchaseAt: string; //预采购时间  格式  2022-03-31
  coverMethod: number;
  summationMethod: number;
  importMethod: number;
  file?: any; //文件（没有就不用传）
}>({
  projectId: projectInfo.value.id,
  projectCode: projectInfo.value.projectCode,
  prePurchaseAt: '',
  coverMethod: null,
  summationMethod: null,
  importMethod: null,
  file: null
});
const excelCode = ref('');

//生成唯一id
function generateUniqueId() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}
const httpRequest = ({ file }) => {
  return uploadApi({ file });
};
const onCancel = () => {
  props.remove();
};

const againSubmitPerson = async (inVO, dataList) => {
  const { data } = await againSubmit({ inVO, dataList });
  if (data.failCount === 0) {
    XrkMessage.success('导入成功');
    emits('success');
    props.remove();
  } else {
    createDialog({
      width: '1300px',
      title: '导入失败',
      showClose: true,
      showFooter: false,
      contentRender: done => {
        return (
          <ProjectPersonFailTable
            form={{
              excelCode: excelCode.value
            }}
            onAgainSubmit={async ({ dataList }) => {
              await againSubmitPerson(inVO, dataList);
            }}
            importCount={data.importCount}
            failCount={data.failCount}
            dataList={data.dataList}
            done={done}
          ></ProjectPersonFailTable>
        );
      }
    });
    props.remove();
  }
};

const projectShowFlag = ref(1);

const onConfirm = async () => {
  await formRef.value.validate();
  if (!fileList.value.length) {
    XrkMessage.error('请上传文件！');
  } else {
    excelCode.value = generateUniqueId();
    const { data } = await checkImportExcel({
      file: fileList.value[0].raw,
      projectCode: projectInfo.value.projectCode
    });

    const submit = async () => {
      const inVO = {
        projectShowFlag: projectShowFlag.value,
        excelName: fileList.value[0].name,
        projectId: form.projectId,
        projectCode: form.projectCode,
        prePurchaseAt: form.prePurchaseAt,
        coverMethod: form.coverMethod,
        summationMethod: form.summationMethod,
        importMethod: form.importMethod,
        excelUploadUrl: fileList.value[0].url,
        excelCode: excelCode.value
      };
      const params = {
        inVO: JSON.stringify(inVO),
        file: fileList.value[0].raw
      };
      const { data } = await importProjectPeople(params);
      if (data.failCount === 0) {
        XrkMessage.success('导入成功');
        emits('success');
        props.remove();
      } else {
        createDialog({
          width: '1300px',
          title: '导入失败',
          showClose: true,
          showFooter: false,
          contentRender: done => {
            return (
              <ProjectPersonFailTable
                form={{
                  excelCode: excelCode.value
                }}
                onAgainSubmit={async ({ dataList }) => {
                  await againSubmitPerson(inVO, dataList);
                }}
                importCount={data.importCount}
                failCount={data.failCount}
                dataList={data.dataList}
                done={done}
              ></ProjectPersonFailTable>
            );
          }
        });
        props.remove();
      }
    };
    if (data[1] > 0) {
      const tips = `您上传的人员名单为${data[0]}人，其中${data[1]}人未设置人员标签，是否继续？`;
      createDialog({
        width: '500px',
        title: '是否继续',
        showClose: false,
        showFooter: true,
        contentRender: () => {
          return (
            <>
              <div style="padding: 20px">
                <p>{tips}</p>
                <BaseCheckbox
                  v-model={projectShowFlag.value}
                  trueValue={2}
                  falseValue={1}
                >
                  本项目不再提示
                </BaseCheckbox>
              </div>
            </>
          );
        },
        async beforeConfirm() {
          await submit();
        },
        async beforeCancel(done) {
          await done();
        }
      });
    } else {
      await submit();
    }
  }
};

/**
 * 清零上期预采购任务量
 * @param {number} projectId 项目ID
 */
async function removeLatestTask() {
  await XrkMessageBox.confirm(
    '此操作将清零上期预采购任务量, 是否继续?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }
  );

  // 显示loading
  const loading = XrkLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });

  try {
    // 发送清零任务请求
    await cleanProjectWorkload({
      projectId: projectInfo.value.id
    });

    // 显示成功提示
    XrkMessage.success('上期预采购任务量已清零');
    emits('success');
    // 关闭loading
    loading.close();
  } catch (e) {
    // 关闭loading
    loading.close();
  }
}

const onError = errorInfo => {
  XrkMessage.error(errorInfo.msg);
};

const procurementPersonnel = () => {
  const excelGroupCode = isGeti.value
    ? 'import_individual_pre_purchase'
    : 'import_pre_purchase';
  downloadTemplate({
    excelGroupCode
  });
};

const downLodTaskPlanExcel = async () => {
  await downloadSurplus({
    projectId: projectInfo.value.id
  });
};
const lastMonthDate = new Date();
lastMonthDate.setMonth(lastMonthDate.getMonth() + 1);
lastMonthDate.setDate(0);
form.prePurchaseAt = formatter.date(lastMonthDate.getTime()) as string;
</script>
